 	/** ===== Webpack2 Polyfill ===== **/
 	(function(){
 		var _global = this;
 		var module = undefined;
 		/** ===== Function.prototype.bind Polyfill ===== **/
 		if (!Function.prototype.bind) {
 		  Function.prototype.bind = function(oThis) {
 		    if (typeof this !== 'function') {
 		                                                   
 		                                     
 		      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
 		    }
 		
 		    var aArgs   = Array.prototype.slice.call(arguments, 1),
 		        fToBind = this,
 		        fNOP    = function() {},
 		        fBound  = function() {
 		          return fToBind.apply(this instanceof fNOP
 		                 ? this
 		                 : oThis,
 		                 aArgs.concat(Array.prototype.slice.call(arguments)));
 		        };
 		
 		    if (this.prototype) {
 		                                                             
 		      fNOP.prototype = this.prototype; 
 		    }
 		    fBound.prototype = new fNOP();
 		
 		    return fBound;
 		  };
 		}

 		/** ===== Function.prototype.bind Polyfill end ===== **/
 		/** ===== Object.keys Polyfill ===== **/
 		                                                                                                    
 		if (!Object.keys) {
 		  Object.keys = (function() {
 		    'use strict';
 		    var hasOwnProperty = Object.prototype.hasOwnProperty,
 		        hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
 		        dontEnums = [
 		          'toString',
 		          'toLocaleString',
 		          'valueOf',
 		          'hasOwnProperty',
 		          'isPrototypeOf',
 		          'propertyIsEnumerable',
 		          'constructor'
 		        ],
 		        dontEnumsLength = dontEnums.length;
 		
 		    return function(obj) {
 		      if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
 		        throw new TypeError('Object.keys called on non-object');
 		      }
 		
 		      var result = [], prop, i;
 		
 		      for (prop in obj) {
 		        if (hasOwnProperty.call(obj, prop)) {
 		          result.push(prop);
 		        }
 		      }
 		
 		      if (hasDontEnumBug) {
 		        for (i = 0; i < dontEnumsLength; i++) {
 		          if (hasOwnProperty.call(obj, dontEnums[i])) {
 		            result.push(dontEnums[i]);
 		          }
 		        }
 		      }
 		      return result;
 		    };
 		  }());
 		}

 		/** ===== Object.keys Polyfill end ===== **/
 		/** ===== Promise Polyfill ===== **/
 		if(!_global.Promise){
 			(function (root) {

 			                                                                         
 			                                                                 
 			  var setTimeoutFunc = setTimeout;

 			  function noop() {}
 			  
 			                                         
 			  function bind(fn, thisArg) {
 			    return function () {
 			      fn.apply(thisArg, arguments);
 			    };
 			  }

 			  function Promise(fn) {
 			    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
 			    if (typeof fn !== 'function') throw new TypeError('not a function');
 			    this._state = 0;
 			    this._handled = false;
 			    this._value = undefined;
 			    this._deferreds = [];

 			    doResolve(fn, this);
 			  }

 			  function handle(self, deferred) {
 			    while (self._state === 3) {
 			      self = self._value;
 			    }
 			    if (self._state === 0) {
 			      self._deferreds.push(deferred);
 			      return;
 			    }
 			    self._handled = true;
 			    Promise._immediateFn(function () {
 			      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
 			      if (cb === null) {
 			        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
 			        return;
 			      }
 			      var ret;
 			      try {
 			        ret = cb(self._value);
 			      } catch (e) {
 			        reject(deferred.promise, e);
 			        return;
 			      }
 			      resolve(deferred.promise, ret);
 			    });
 			  }

 			  function resolve(self, newValue) {
 			    try {
 			                                                                                                                       
 			      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
 			      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
 			        var then = newValue.then;
 			        if (newValue instanceof Promise) {
 			          self._state = 3;
 			          self._value = newValue;
 			          finale(self);
 			          return;
 			        } else if (typeof then === 'function') {
 			          doResolve(bind(then, newValue), self);
 			          return;
 			        }
 			      }
 			      self._state = 1;
 			      self._value = newValue;
 			      finale(self);
 			    } catch (e) {
 			      reject(self, e);
 			    }
 			  }

 			  function reject(self, newValue) {
 			    self._state = 2;
 			    self._value = newValue;
 			    finale(self);
 			  }

 			  function finale(self) {
 			    if (self._state === 2 && self._deferreds.length === 0) {
 			      Promise._immediateFn(function() {
 			        if (!self._handled) {
 			          Promise._unhandledRejectionFn(self._value);
 			        }
 			      });
 			    }

 			    for (var i = 0, len = self._deferreds.length; i < len; i++) {
 			      handle(self, self._deferreds[i]);
 			    }
 			    self._deferreds = null;
 			  }

 			  function Handler(onFulfilled, onRejected, promise) {
 			    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
 			    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
 			    this.promise = promise;
 			  }

 			     
 			                                                                   
 			                                                     
 			    
 			                                          
 			     
 			  function doResolve(fn, self) {
 			    var done = false;
 			    try {
 			      fn(function (value) {
 			        if (done) return;
 			        done = true;
 			        resolve(self, value);
 			      }, function (reason) {
 			        if (done) return;
 			        done = true;
 			        reject(self, reason);
 			      });
 			    } catch (ex) {
 			      if (done) return;
 			      done = true;
 			      reject(self, ex);
 			    }
 			  }

 			  Promise.prototype['catch'] = function (onRejected) {
 			    return this.then(null, onRejected);
 			  };

 			  Promise.prototype.then = function (onFulfilled, onRejected) {
 			    var prom = new (this.constructor)(noop);

 			    handle(this, new Handler(onFulfilled, onRejected, prom));
 			    return prom;
 			  };

 			  Promise.all = function (arr) {
 			    var args = Array.prototype.slice.call(arr);

 			    return new Promise(function (resolve, reject) {
 			      if (args.length === 0) return resolve([]);
 			      var remaining = args.length;

 			      function res(i, val) {
 			        try {
 			          if (val && (typeof val === 'object' || typeof val === 'function')) {
 			            var then = val.then;
 			            if (typeof then === 'function') {
 			              then.call(val, function (val) {
 			                res(i, val);
 			              }, reject);
 			              return;
 			            }
 			          }
 			          args[i] = val;
 			          if (--remaining === 0) {
 			            resolve(args);
 			          }
 			        } catch (ex) {
 			          reject(ex);
 			        }
 			      }

 			      for (var i = 0; i < args.length; i++) {
 			        res(i, args[i]);
 			      }
 			    });
 			  };

 			  Promise.resolve = function (value) {
 			    if (value && typeof value === 'object' && value.constructor === Promise) {
 			      return value;
 			    }

 			    return new Promise(function (resolve) {
 			      resolve(value);
 			    });
 			  };

 			  Promise.reject = function (value) {
 			    return new Promise(function (resolve, reject) {
 			      reject(value);
 			    });
 			  };

 			  Promise.race = function (values) {
 			    return new Promise(function (resolve, reject) {
 			      for (var i = 0, len = values.length; i < len; i++) {
 			        values[i].then(resolve, reject);
 			      }
 			    });
 			  };

 			                                                        
 			  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
 			    function (fn) {
 			      setTimeoutFunc(fn, 0);
 			    };

 			  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
 			    if (typeof console !== 'undefined' && console) {
 			      console.warn('Possible Unhandled Promise Rejection:', err);                                  
 			    }
 			  };

 			     
 			                                                    
 			                                             
 			                
 			     
 			  Promise._setImmediateFn = function _setImmediateFn(fn) {
 			    Promise._immediateFn = fn;
 			  };

 			     
 			                                                          
 			                                                                    
 			                
 			     
 			  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
 			    Promise._unhandledRejectionFn = fn;
 			  };
 			  
 			  if (typeof module !== 'undefined' && module.exports) {
 			    module.exports = Promise;
 			  } else if (!root.Promise) {
 			    root.Promise = Promise;
 			  }

 			})(this);
 		}
 		/** ===== Promise Polyfill end ===== **/
 		/** ===== Object.defineProperty Polyfill ===== **/
 		              
 		
 		                               
 		             
 		                                   
 		                                                                 
 		                          
 		                                                                                      
 		         
 		                          
 		                                                                                              
 		         
 		       
 		     
 		   
 		
 		     
 		  
 		
 		(function() {
 		  if (!Object.defineProperty ||
 		    !(function() {
 		      try {
 		        Object.defineProperty({}, 'x', {});
 		        return true;
 		      } catch (e) {
 		        return false;
 		      }
 		    }())) {
 		    var orig = Object.defineProperty;
 		    Object.defineProperty = function(o, prop, desc) {
 		                                                                                      
 		      if (orig) {
 		        try {
 		          return orig(o, prop, desc);
 		        } catch (e) {}
 		      }
 		      if (o !== Object(o)) {
 		        throw TypeError("Object.defineProperty called on non-object");
 		      }
 		      if (Object.prototype.__defineGetter__ && ('get' in desc)) {
 		        Object.prototype.__defineGetter__.call(o, prop, desc.get);
 		
 		      }
 		      if (Object.prototype.__defineSetter__ && ('set' in desc)) {
 		        Object.prototype.__defineSetter__.call(o, prop, desc.set);
 		      }
 		      if ('value' in desc) {
 		        o[prop] = desc.value;
 		      }
 		      return o;
 		    };
 		  }
 		}());
 		/** ===== Object.defineProperty Polyfill end ===== **/
 		/** ===== Array Polyfill ===== **/
 		if (!Array.prototype.some) {
 		  Array.prototype.some = function(fun                ) {
 		    'use strict';

 		    if (this === void 0 || this === null)
 		      throw new TypeError();

 		    var t = Object(this);
 		    var len = t.length >>> 0;
 		    if (typeof fun !== 'function')
 		      throw new TypeError();

 		    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
 		    for (var i = 0; i < len; i++) {
 		      if (i in t && fun.call(thisArg, t[i], i, t))
 		        return true;
 		    }

 		    return false;
 		  };

 		}

 		                     
 		if (Array.prototype.map === undefined) {
 		  Array.prototype.map = function(fn) {
 		    var rv = [];

 		    for (var i = 0, l = this.length; i < l; i++)
 		      rv.push(fn(this[i]));

 		    return rv;
 		  };
 		}

 		                        
 		if (Array.prototype.filter === undefined) {
 		  Array.prototype.filter = function(fn) {
 		    var rv = [];

 		    for (var i = 0, l = this.length; i < l; i++)
 		      if (fn(this[i])) rv.push(this[i]);

 		    return rv;
 		  };
 		}

 		Array.prototype.forEach = function(callback, thisArg) {
 		  var T, k;
 		  if (this == null) {
 		    throw new TypeError(' this is null or not defined');
 		  }
 		  var O = Object(this);
 		  var len = O.length >>> 0;

 		  if (typeof callback !== "function") {
 		    throw new TypeError(callback + ' is not a function');
 		  }
 		  if (arguments.length > 1) {
 		    T = thisArg;
 		  }
 		  k = 0;
 		  while (k < len) {
 		    var kValue;
 		    if (k in O) {
 		      kValue = O[k];
 		      callback.call(T, kValue, k, O);
 		    }
 		    k++;
 		  }
 		};

 		Array.prototype.every = function(fun) {
 		  if (this === void 0 || this === null)
 		    throw new TypeError();
 		  var t = Object(this);
 		  var len = t.length >>> 0;
 		  if (typeof fun !== 'function')
 		    throw new TypeError();
 		  var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
 		  for (var i = 0; i < len; i++) {
 		    if (i in t && !fun.call(thisArg, t[i], i, t))
 		      return false;
 		  }
 		  return true;
 		};

 		Array.from = (function() {
 		  var toStr = Object.prototype.toString;
 		  var isCallable = function(fn) {
 		    return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
 		  };
 		  var toInteger = function(value) {
 		    var number = Number(value);
 		    if (isNaN(number)) {
 		      return 0;
 		    }
 		    if (number === 0 || !isFinite(number)) {
 		      return number;
 		    }
 		    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
 		  };
 		  var maxSafeInteger = Math.pow(2, 53) - 1;
 		  var toLength = function(value) {
 		    var len = toInteger(value);
 		    return Math.min(Math.max(len, 0), maxSafeInteger);
 		  };
 		  return function from(arrayLike                       ) {
 		    var C = this;
 		    var items = Object(arrayLike);
 		    if (arrayLike == null) {
 		      throw new TypeError("Array.from requires an array-like object - not null or undefined");
 		    }
 		    var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
 		    var T;
 		    if (typeof mapFn !== 'undefined') {
 		      if (!isCallable(mapFn)) {
 		        throw new TypeError('Array.from: when provided, the second argument must be a function');
 		      }
 		      if (arguments.length > 2) {
 		        T = arguments[2];
 		      }
 		    }
 		    var len = toLength(items.length);
 		    var A = isCallable(C) ? Object(new C(len)) : new Array(len);
 		    var k = 0;
 		    var kValue;
 		    while (k < len) {
 		      kValue = items[k];
 		      if (mapFn) {
 		        A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
 		      } else {
 		        A[k] = kValue;
 		      }
 		      k += 1;
 		    }
 		    A.length = len;
 		    return A;
 		  };
 		}());

 		Array.prototype.filter = function(fun                ) {
 		  if (this === void 0 || this === null)
 		    throw new TypeError();

 		  var t = Object(this);
 		  var len = t.length >>> 0;
 		  if (typeof fun !== "function")
 		    throw new TypeError();

 		  var res = [];
 		  var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
 		  for (var i = 0; i < len; i++) {
 		    if (i in t) {
 		      var val = t[i];
 		      if (fun.call(thisArg, val, i, t))
 		        res.push(val);
 		    }
 		  }
 		  return res;
 		};

 		Array.prototype.find = function(predicate) {
 		  if (this == null) {
 		    throw new TypeError('Array.prototype.find called on null or undefined');
 		  }
 		  if (typeof predicate !== 'function') {
 		    throw new TypeError('predicate must be a function');
 		  }
 		  var list = Object(this);
 		  var length = list.length >>> 0;
 		  var thisArg = arguments[1];
 		  var value;

 		  for (var i = 0; i < length; i++) {
 		    value = list[i];
 		    if (predicate.call(thisArg, value, i, list)) {
 		      return value;
 		    }
 		  }
 		  return undefined;
 		};


 		Array.prototype.findIndex = function(predicate) {
 		  if (this === null) {
 		    throw new TypeError('Array.prototype.findIndex called on null or undefined');
 		  }
 		  if (typeof predicate !== 'function') {
 		    throw new TypeError('predicate must be a function');
 		  }
 		  var list = Object(this);
 		  var length = list.length >>> 0;
 		  var thisArg = arguments[1];
 		  var value;

 		  for (var i = 0; i < length; i++) {
 		    value = list[i];
 		    if (predicate.call(thisArg, value, i, list)) {
 		      return i;
 		    }
 		  }
 		  return -1;
 		};

 		Array.prototype.includes = function(e) {
 		  var len = this.length;
 		  for (var i = 0; i < len; i++) {
 		    if (e = this[i]) {
 		      return true;
 		    }
 		  }
 		  return false;
 		}

 		Array.prototype.indexOf = function(searchElement, fromIndex) {
 		  var k;
 		  if (this == null) {
 		    throw new TypeError('"this" is null or not defined');
 		  }
 		  var O = Object(this);
 		  var len = O.length >>> 0;
 		  if (len === 0) {
 		    return -1;
 		  }
 		  var n = +fromIndex || 0;
 		  if (Math.abs(n) === Infinity) {
 		    n = 0;
 		  }
 		  if (n >= len) {
 		    return -1;
 		  }
 		  k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
 		  while (k < len) {
 		    if (k in O && O[k] === searchElement) {
 		      return k;
 		    }
 		    k++;
 		  }
 		  return -1;
 		};

 		Array.prototype.reduce = function(callback                    ) {
 		  'use strict';
 		  if (this === null) {
 		    throw new TypeError('Array.prototype.reduce called on null or undefined');
 		  }
 		  if (typeof callback !== 'function') {
 		    throw new TypeError(callback + ' is not a function');
 		  }
 		  var t = Object(this),
 		    len = t.length >>> 0,
 		    k = 0,
 		    value;
 		  if (arguments.length >= 2) {
 		    value = arguments[1];
 		  } else {
 		    while (k < len && !(k in t)) {
 		      k++;
 		    }
 		    if (k >= len) {
 		      throw new TypeError('Reduce of empty array with no initial value');
 		    }
 		    value = t[k++];
 		  }
 		  for (; k < len; k++) {
 		    if (k in t) {
 		      value = callback(value, t[k], k, t);
 		    }
 		  }
 		  return value;
 		};


 		Array.prototype.reduceRight = function(callback                    ) {
 		  if (null === this || 'undefined' === typeof this) {
 		    throw new TypeError('Array.prototype.reduce called on null or undefined');
 		  }
 		  if ('function' !== typeof callback) {
 		    throw new TypeError(callback + ' is not a function');
 		  }
 		  var t = Object(this),
 		    len = t.length >>> 0,
 		    k = len - 1,
 		    value;
 		  if (arguments.length >= 2) {
 		    value = arguments[1];
 		  } else {
 		    while (k >= 0 && !(k in t)) {
 		      k--;
 		    }
 		    if (k < 0) {
 		      throw new TypeError('Reduce of empty array with no initial value');
 		    }
 		    value = t[k--];
 		  }
 		  for (; k >= 0; k--) {
 		    if (k in t) {
 		      value = callback(value, t[k], k, t);
 		    }
 		  }
 		  return value;
 		};
 		/** ===== Array Polyfill end ===== **/
 		/** ===== String.trim Polyfill ===== **/
 		if (!String.prototype.trim) {
 		    String.prototype.trim = function () {
 		        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
 		    };
 		}
 		/** ===== String.trim Polyfill end ===== **/
 		/** ===== String.trim Polyfill ===== **/
 		if (typeof Object.create !== 'function') {
 		    Object.create = function(o, props) {
 		        function F() {}
 		        F.prototype = o;

 		        if (typeof(props) === "object") {
 		            for (prop in props) {
 		                if (props.hasOwnProperty((prop))) {
 		                    F[prop] = props[prop];
 		                }
 		            }
 		        }
 		        return new F();
 		    };
 		}
 		/** ===== String.trim Polyfill end ===== **/
 	}).call((function(){
 	if(typeof window != "undefined") return window;
 	if(typeof global != "undefined") return global;
 	if(typeof self != "undefined") return self;
 	})())
 	/** ===== Webpack2 Polyfill end ===== **/

 	// The module cache
 	var installedModules = {};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}


 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// identity function for calling harmony imports with the correct context
 	__webpack_require__.i = function(value) { return value; };

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 42);



// WEBPACK FOOTER //
// webpack/bootstrap 0f86e7d8c4c33096ed90